var url_domain = window.location.host;
var config_url = '';

if (window.Capacitor && window.Capacitor.platform !== 'web') {
    config_url = 'https://vili.com.ar/api/1.0/';
} else {
    if (url_domain == 'localhost:8080') {
        // config_url = 'https://apimono.monotributa.com/api/1.0/';
        //config_url = 'http://127.0.0.1:8000/api/1.0/';
        config_url = 'http://127.0.0.1:8000/';
        //config_url = 'https://appb.vili.com.ar/api/1.0/';
        //config_url = "http://appb.oteroweb.test/api/1.0/";

    } else if (url_domain == 'app.vili.com.ar') {
        config_url = 'https://vili.com.ar/api/1.0/';
    } else if (url_domain == '146.235.61.23') {
        config_url = 'http://146.235.61.23/api/1.0/';
    } else if (url_domain == 'vili.com.ar') {
        config_url = 'https://vili.com.ar/api/1.0/';
    }
}
//config_url = 'https://vili.com.ar/api/1.0/';
//console.log('Backend Conected: ' + config_url)
export const apiPath = config_url;